import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  const displayCategories = categories.filter((c) => c.slug !== 'all');

  return (
    <section className="py-14 md:py-20 bg-background-50" aria-labelledby="category-title">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2
            id="category-title"
            className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3"
          >
            漫画分类
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            涵盖多种漫画类型，无论您喜欢什么风格，都能在这里找到心仪的韩漫作品
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {displayCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 bg-background-100 rounded-xl border border-background-200/70 hover:border-primary-300 hover:bg-primary-50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                <i className={`${cat.icon} text-xl md:text-2xl`} style={{ width: '24px', height: '24px' }}></i>
              </div>
              <span className="font-heading text-sm md:text-base text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}